import Vue from 'vue'

// LogRocket
import LogRocket from 'logrocket'

Vue.prototype.$logRocket = LogRocket
